/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
export const DateRangeByFilter = ({ handleDateRangeBy, dateRangeBy }: any) => {
  const filter_list = [
    {
      label: "Processed date",
      value: "processed_date",
    },
    {
      label: "Order date",
      value: "order_date",
    },
    {
      label: "Delivery Date",
      value: "delivery_date",
    },
  ];
  return (
    <div>
      <Select
        value={dateRangeBy}
        onValueChange={handleDateRangeBy}
        defaultValue="processed_date"
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select Date Range By " />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {filter_list.map((item) => {
              return (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              );
            })}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
